import { useRef, useEffect } from 'react';

import { fg } from '@atlassian/jira-feature-gating';
import { autoBeforeEachTest } from '@jira/platform__utils-auto-before-each-test/src/auto-before-each-test.tsx';

// Cloned the attributes from AnalyticsPayload type
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export type PageDwellAttributes = Record<string, any>;

const attributesList: PageDwellAttributes[] = [];
// Clear the shared attributes list before each test to prevent test pollution
// and ensure each test starts with a clean state
autoBeforeEachTest(() => {
	attributesList.length = 0;
});

const setPageDwellAttributes = (
	newAttributes: PageDwellAttributes,
	lastAttributes: PageDwellAttributes | null,
): void => {
	let lastAttributesIndex = -1;
	if (lastAttributes) {
		lastAttributesIndex = attributesList.findIndex((object) => object === lastAttributes);
	}

	if (lastAttributesIndex !== -1) {
		attributesList[lastAttributesIndex] = newAttributes;
	} else {
		attributesList.push(newAttributes);
	}
};

const clearPageDwellAttributes = (clearAttributes: PageDwellAttributes): void => {
	const index = attributesList.findIndex((object) => object === clearAttributes);
	if (index !== -1) {
		attributesList.splice(index, 1);
	}
};

export const getPageDwellAttributes = (): PageDwellAttributes => {
	const result: PageDwellAttributes = {};
	attributesList.forEach((object) => {
		Object.assign(result, object);
	});
	return result;
};

export const useDwellTime = (attributes: PageDwellAttributes): void => {
	const prevAttributes = useRef<PageDwellAttributes | null>(null);

	useEffect(() => {
		if (!fg('jira-page-dwell-custom-attributes')) return;

		setPageDwellAttributes(attributes, prevAttributes.current);
		prevAttributes.current = attributes;

		return () => {
			if (prevAttributes.current) {
				clearPageDwellAttributes(prevAttributes.current);
			}
		};
	}, [attributes]);
};
